import i18n from 'i18n';

export const POLICY_TABS = [
  {
    id: 'documents',
    title: i18n.t('supplierPolicy.tabs.requiredDocuments'),
  },
  {
    id: 'audit',
    title: i18n.t('supplierPolicy.tabs.audits'),
  },
];

export const activePolicyRouteId = (pathname: string): string => {
  return POLICY_TABS.find((tab) => pathname?.includes(tab.id))?.id || 'documents';
};
